import { LocationObject } from '../../../swagger-api';

export interface LocationQueryOptions {
  includeStreet?: boolean;
  includeSubregion?: boolean;
}

export function getLocation(location: LocationObject, options?: LocationQueryOptions): string {
  const city: string = location.city ? `${location.city}, ` : '';
  const region: string = location.region ? `${location.region}, ` : '';

  const street: string = location.street && options && options.includeStreet ? `${location.street}, ` : '';
  const subregion: string = location.subregion && options && options.includeSubregion ? `${location.subregion}, ` : '';

  return `${city}${region}${subregion}${street}${location.country.full_name}`;
}
